import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { directoryApi, type Account } from '../client';

const queryKey = ['directory', 'accounts', 'available'] as const;

/** Stable query key for cache lookups, invalidations, prefetches, etc. */
useAvailableAccounts.queryKey = queryKey;

/**
 * TanStack Query hook over `GET /directory/api/v1/accounts/available`.
 * Returns every account the signed-in user belongs to. The AccountSwitcher
 * displays these; role-resolution helpers read the same payload via the
 * platform account store.
 *
 * Pass `{ enabled: false }` to suppress the call (e.g. during the auth
 * bootstrap before a token exists).
 */
export function useAvailableAccounts(
  options?: Omit<UseQueryOptions<Account[], Error>, 'queryKey' | 'queryFn'>,
) {
  return useQuery<Account[], Error>({
    queryKey,
    queryFn: directoryApi.getAvailableAccounts,
    staleTime: 5 * 60 * 1000,
    retry: 1,
    ...options,
  });
}
